module.exports = __webpack_public_path__ + "static/media/blue1.b9949e3b.jpg";